import { Component, Output, EventEmitter, Input  } from '@angular/core';

@Component({
  selector: 'app-registration-form',
  templateUrl: './registration-form.component.html',
  styleUrl: './registration-form.component.css'
})
export class RegistrationFormComponent {
  @Input() argument: string = '';  // The dynamic argument passed from the parent
  @Output() formSubmit = new EventEmitter<string>();  // Event emitter to send the response

  itemName: string = '';  // Form data

  // Handle form submission
  onSubmit() {
    if (this.itemName) {
      // Emit "Yes" if the form is valid
      this.formSubmit.emit('Yes');
    } else {
      // Emit "No" if the form is invalid
      this.formSubmit.emit('No');
    }
  }

  // Close modal (emit "No" when canceled)
  closeModal() {
    this.formSubmit.emit('No');  // Emit "No" if the user closes the modal without submitting
  }
}
